"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Badge = _interopRequireDefault(require("@material-ui/core/Badge"));
var _bookmarkContext = _interopRequireDefault(require("@micado-digital/react-bookmark/context/bookmarkContext"));
var _ReactLink = _interopRequireDefault(require("@micado-digital/react-link/ReactLink"));
var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));
var _useSystemLinks = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useSystemLinks"));
var _getCounterFromLocalStorage = _interopRequireDefault(require("../../utils/bookmark/getCounterFromLocalStorage"));
var _BookmarkIcon = _interopRequireDefault(require("./BookmarkIcon.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BookmarkIcon = () => {
  var _systemLink;
  const [bookmarkData] = (0, _react.useContext)(_bookmarkContext.default);
  const [counter, setCounter] = (0, _react.useState)(0);
  const systemLink = (0, _useSystemLinks.default)();
  const css = (0, _BookmarkIcon.default)();
  (0, _react.useEffect)(() => {
    const interval = setInterval(() => {
      setCounter((0, _getCounterFromLocalStorage.default)());
    }, 1000);
    return () => clearTimeout(interval);
  }, []);
  (0, _react.useEffect)(() => {
    setCounter(bookmarkData === null || bookmarkData === void 0 ? void 0 : bookmarkData.length);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(bookmarkData)]);
  const bookmarkUrl = (_systemLink = systemLink("shop-bookmark")) !== null && _systemLink !== void 0 ? _systemLink : "/";
  return /*#__PURE__*/_react.default.createElement(_ReactLink.default, {
    "aria-label": "bookmark",
    className: (0, _clsx.default)(css.bookmarkIcon, "mco-shop-bookmark-icon"),
    to: bookmarkUrl
  }, /*#__PURE__*/_react.default.createElement(_Badge.default, {
    badgeContent: counter,
    className: (0, _clsx.default)(css.badge, "mco-shop-cart-icon__badge"),
    color: "primary",
    overlap: "rectangular"
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: "/img/icons/shop/bookmark.svg",
    size: 24
  })));
};
var _default = exports.default = BookmarkIcon;